import config from "@/config"
import { msTimestampFormat } from "@/utils"

export const getColumns = [
    {
        title: "文本ID",
        dataIndex: "id",
        width: 80
    },
    {
        title: "文本类型",
        dataIndex: "name",
        width: 150
    },
    {
        title: "英文描述",
        dataIndex: "en_name",
        width: 200
    },
    {
        title: "创建人",
        dataIndex: "uid",
        width: 120,
        renderProps: {
            showPopover: true,
            platform_id: config.api.PID
        },
        renderType: "user"
    },
    {
        title: "创建时间",
        dataIndex: "create_time",
        width: 150,
        customRender: (text: number) => {
            return text ? msTimestampFormat(text, "YYYY-MM-DD HH:mm:ss") : "-"
        }
    }
]
